import { useEffect } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getUser, isLogin } from "../Store/Actions/AuthAction";
import Storage from "../utills/AsyncStorage";

export default function AuthFromQuery() {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  console.log("standing on query wrapper");

  useEffect(() => {
    const q = searchParams.get("q");
    if (!q) return;

    try {
      const decoded = JSON.parse(atob(q));
      Storage.setToken(decoded?.token);
      Storage.setUser("@user", JSON.stringify(decoded));
      Storage.setERole("@role", JSON.stringify(decoded?.type));
      Storage.setRole("role", JSON.stringify(decoded?.type));
      dispatch(getUser(decoded));
      dispatch(isLogin(true));
    } catch (err) {
      console.log("Invalid query param");
    }
  }, [searchParams, dispatch]);

  return null;
}
